import {
  OktonLoadingCard,
  OktonErrorCard,
  OktonDataGrid,
  ColunaGrid,
  TAMANHOS_PAGINA,
  useGrid,
} from '@okton/platform-ui';
import {
  Box,
  Button,
  Flex,
  Heading,
  useColorModeValue,
} from '@chakra-ui/react';
import { Plus } from 'lucide-react';
import React from 'react';
import { colunasDataGrid } from '../../utils/colunasDataGrid';

interface GridMovimentosProps<T> {
  titulo: string;
  novo: string;
  onNovo: () => void;
  rows: T[];
  colunas: ColunaGrid<T>[];
  busca: string;
  loading: boolean;
  error: boolean;
  onRetry: () => void;
  habilitado: boolean;
  vazio: string;
  chave: (row: T) => string;
  // Conteúdo de cada coluna, pela chave; a que faltar mostra o valor dela.
  celulas: Partial<Record<string, (row: T) => React.ReactNode>>;
}

function GridMovimentos<T>({
  titulo,
  novo,
  onNovo,
  rows,
  colunas,
  busca,
  loading,
  error,
  onRetry,
  habilitado,
  vazio,
  chave,
  celulas,
}: GridMovimentosProps<T>) {
  const bg = useColorModeValue('white', 'gray.800');
  const {
    ordenacao,
    alternarOrdenacao,
    itens: visiveis,
    filtrados,
    pagina,
    setPagina,
    tamanhoPagina,
    setTamanhoPagina,
  } = useGrid(rows, colunas, busca);

  return (
    <Box mt="5" bg={bg} borderWidth="1px" rounded="2xl" overflowX="auto">
      <Flex px="5" py="4" align="center" justify="space-between" gridGap="2">
        <Heading fontSize="lg" fontWeight="medium">
          {titulo}
        </Heading>
        <Button
          size="sm"
          leftIcon={<Plus size={16} />}
          colorScheme="blue"
          variant="outline"
          isDisabled={!habilitado}
          onClick={onNovo}
        >
          {novo}
        </Button>
      </Flex>
      {loading ? (
        <OktonLoadingCard h="180px" />
      ) : error ? (
        <OktonErrorCard h="180px" onRetry={onRetry} />
      ) : !habilitado ? (
        <Flex py="14" justify="center" color="gray.500">
          Selecione uma conta e um período válido
        </Flex>
      ) : filtrados.length === 0 ? (
        <Flex py="14" justify="center" color="gray.500">
          {busca ? 'Nada encontrado para a busca' : vazio}
        </Flex>
      ) : (
        <Box px="5" pb="5">
          <OktonDataGrid
            rows={visiveis}
            columns={colunasDataGrid(
              colunas,
              ordenacao,
              alternarOrdenacao,
              celulas,
            )}
            getRowId={chave}
            page={pagina + 1}
            pageSize={tamanhoPagina}
            total={filtrados.length}
            pageSizeOptions={TAMANHOS_PAGINA}
            onPageChange={nova => setPagina(nova - 1)}
            onPageSizeChange={setTamanhoPagina}
          />
        </Box>
      )}
    </Box>
  );
}

export default GridMovimentos;
